<template>
    <contentCard :loading="loading">
        <template slot="cardContent">
			<div>
                <v-row justify="center" >
                    <v-col class="text-center col-md-7">
                        <div class="font-weight-bold body-1">
                            Editar Orden de compra
                        </div>
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-col cols="12" md="7">
                        <v-form ref="form" @submit.prevent="save">
                            <item-form ref="POForm" :values="form" @save="save" :serverErrors="serverErrors" :edit="true"></item-form>
                        </v-form>
                    </v-col>
                    
                </v-row>
            </div>

            <v-row justify="center" align="end">
				<v-col cols="12" md="7" class="">
                    <v-row justify="end" class="px-3 py-3">
                        <secondary-button data-cy="cancel-btn" :props="cancelBtnData" class="mr-0 mr-sm-2 mb-3 mb-sm-0"></secondary-button>
                        <primary-button data-cy="accept-btn" :props="saveBtnData" class=""></primary-button>  
                    </v-row>
				</v-col>
			</v-row>
        </template>
    </contentCard>
</template>

<script>
import Utils from '../../../helpers/Utils';
import POForm from "./Form.vue";
export default {
    components: {
        'item-form': POForm,
    },
	data(){
		return {
            id: this.$route.params.id,
            loading: false,
            serverErrors: {},
            form: {
                work:"",
                supplier: "",
                supplier_id: "",
                supplies: "", 
                baseDate: "",

                requisition_id: "",
                comments: "",
                date: "",
                commodities: [
                    // {
                    //     product_id: "1",
                    //     quantity: "3",
                    //     amount: "4",
                    //     product_name: "test"
                    // }
                ],
            },
            cancelBtnData: {
                text: "Cancelar",
                icon: "",
                to: "PurchaseOrders",
                block:false,
                click: () => {}
            },
            saveBtnData: {
                text: "Guardar",
                icon: "",	
                click: this.save,
                block:false,
                loading: false,
            },
            snackbarProps: {
                visible: false,
				color: 'success',
				timeout: 3000,
				text: '',
            },
		}
    },
    mounted(){
        window.addEventListener('resize', this.onResize, { passive: true });
        this.onResize();
        
        this.index();
        
    },
	methods: {

       
        onResize () {
            
            if(window.innerWidth < 600){
                this.saveBtnData.block = true;
                this.cancelBtnData.block = true;
            }
            else{
                this.saveBtnData.block = false;
                this.cancelBtnData.block = false;
            }
        },
        index(){
            this.loading = true;
            this.$store.state.loading = true;
            this.$api.purchaseOrder.get(this.id)
                .then((resp) => {
                    // let permi = [];
                    this.form.work = `${resp.data.work.folio} - ${resp.data.work.name} `;
                    this.form.supplier = resp.data.supplier.name;
                    this.form.supplier_id = resp.data.supplier.id;
                    this.form.supplies = resp.data.supplier.supplies;
                    this.form.baseDate = resp.data.date;
                    this.form.date = resp.data.date;

                    this.form.requisition_id = resp.data.requisition_id;
                    this.form.comments = resp.data.comments;

                    //commodities 
                    this.form.commodities = resp.data.commodities;

                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                    this.$store.state.loading = false;
                })
            ;
        },
		validate () {
            if(!Utils.objectIsEmpty(this.serverErrors))
                return false;
            // if(this.form.products.length == 0)
            //     return false;
			return this.$refs.form.validate() && this.form.commodities.length > 0;
            // return true;
		},
        save(){
            
            console.log(this.form);
            
            if(this.validate()){
                
                let form = this.prepareRequest(this.form);
                this.saveBtnData.loading = true;
                this.$store.state.loading = true;
                this.$api.purchaseOrder.update(this.id, form)
                    .then(() => {
                        //console.log(response)

                        this.$store.dispatch('snackbarSuccess', `Se ha actualizado correctamente`);
                        this.$router.push({name: 'PurchaseOrders'});
                    })
                    .catch((error) => {
                        var errors = []
                        switch(error.response.status){
                            case 422: 
                                
                                if(("error" in error.response.data)){
                                    if(error.response.data.error instanceof Object){
                                        Object.keys(error.response.data.error).forEach((x) => {
                                            
                                               
                                            console.log(x);
                                            this.serverErrors = error.response.data.error;
                                            error.response.data.error[x].forEach((y) => {
                                                this.serverErrors[x] = Utils.deleteWord(x,y);
                                                errors.push(Utils.deleteWord(x,y))
                                            })
                                        });
                                    }else{
                                        errors.push(error.response.data.error)
                                    }
                                    
                                    this.$store.dispatch('snackbarError', errors.join('.<br>'));
                                }
                               
                            break;
                           
                        }
                        console.log(this.serverErrors)
                       
                    })
                    .finally(() => {
                        this.saveBtnData.loading = false;
                        this.$store.state.loading = false;
                    })
                ;
            }else{
                
                this.$store.dispatch('snackbarError', `Formulario incompleto`);
            }
            // eslint-disable-next-line no-console
        },
        prepareRequest(request)
        {
            let data = JSON.parse(JSON.stringify(request));

            for (let i = 0; i < data.commodities.length; i++) {
                delete data.commodities[i].actions;
                delete data.commodities[i].commodity;
                delete data.commodities[i].parameters;
                delete data.commodities[i].unit;
                delete data.commodities[i].subtotal;
                
                
            }
            return data;
        }
    },
}
</script>

<style>

</style>